import { Link } from "react-router-dom";
import { MODEL } from "../../model";

const TrustedClientsSection = () => {
  return (
    <section className="trusted-clients">
      <h3 className="trusted-clients__heading">Our Trusted Clients</h3>
      <div className="trusted-clients__logos">
        {MODEL.data.trusted_clients.map((v) => {
          return (
            <Link
              key={v.id}
              to={v.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width={100}
                height={100}
                className="trusted-clients__logos__logo"
                src={v.logo}
                alt={v.alt}
                title={v.alt}
              />
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default TrustedClientsSection;
